import { usePlaceNotes } from "../../hooks/usePlaceNotes";
import { InlineLoadingIcon } from "../InlineLoadingIcon/InlineLoadingIcon";
import "./PlaceNotesHighlights.scss";

interface PlaceNotesHighlightsProps {
  placeId: string;
}

export function PlaceNotesHighlights({ placeId }: PlaceNotesHighlightsProps) {
  const { noteCount, loading: isPlaceNotesLoading } = usePlaceNotes(placeId);

  return (
    <div className="place-notes-highlights">
      {isPlaceNotesLoading && <InlineLoadingIcon />}
      {!isPlaceNotesLoading && noteCount > 0 && (
        <a href={`/place/${placeId}#notes`} target="_blank" rel="noreferrer">
          {noteCount} community {noteCount === 1 ? "note" : "notes"}
        </a>
      )}
      {!isPlaceNotesLoading && noteCount === 0 && (
        <span className="no-notes">No community notes yet</span>
      )}
    </div>
  );
}
